import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

/**
 * Auth-related mutations the user-menu uses. Login itself is in pages/Login
 * because it needs to set the token + user on success — fine to keep there.
 */

export type ChangePasswordPayload = {
  current_password: string;
  new_password: string;
};

export function useChangePassword() {
  return useMutation({
    mutationFn: (body: ChangePasswordPayload) =>
      api.post<void>('/auth/change-password', body),
  });
}
